import { ReactNode } from 'react';

interface GRAPHICS {
  AI: () => ReactNode;
  Developer: () => ReactNode;
  Building: () => ReactNode;
  Chart: () => ReactNode;
  Idea: () => ReactNode;
}

const MOBILE_GRAPHICS: GRAPHICS = {
  AI: () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 32.5C0 8.90037 8.90037 0 32.5 0C56.0996 0 65 8.90037 65 32.5C65 56.0996 56.0996 65 32.5 65C8.90037 65 0 56.0996 0 32.5Z"
        fill="white"
      />
      <path
        d="M34.8553 24.7499C34.8553 23.78 34.0245 23 32.9989 23C31.9733 23 31.1426 23.78 31.1426 24.7499C31.1426 25.5499 31.7272 26.1999 32.5066 26.4099V27.9298H33.4809V26.4099C34.2604 26.1999 34.845 25.5599 34.845 24.7499H34.8553Z"
        fill="#BB98F7"
      />
      <path
        d="M32.7329 27.3789C27.2357 27.5189 23 32.0687 23 37.2585C23 38.6185 24.1692 39.7184 25.605 39.7184H39.9224C41.6146 39.7184 42.9992 38.4185 42.9992 36.8185C42.9992 31.5287 38.3737 27.2489 32.7329 27.3889V27.3789ZM30.1689 35.1486C29.5638 35.1486 29.0613 34.6786 29.0613 34.1086C29.0613 33.5387 29.5536 33.0687 30.1689 33.0687C30.7843 33.0687 31.2766 33.5387 31.2766 34.1086C31.2766 34.6786 30.7843 35.1486 30.1689 35.1486ZM35.8303 35.1486C35.2252 35.1486 34.7226 34.6786 34.7226 34.1086C34.7226 33.5387 35.2149 33.0687 35.8303 33.0687C36.4456 33.0687 36.9379 33.5387 36.9379 34.1086C36.9379 34.6786 36.4456 35.1486 35.8303 35.1486Z"
        fill="#8646F2"
      />
      <rect
        x="24.7949"
        y="41"
        width="16.4096"
        height="1.99992"
        rx="0.99996"
        fill="#BB98F7"
      />
    </svg>
  ),
  Developer: () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 32.5C0 8.90037 8.90037 0 32.5 0C56.0996 0 65 8.90037 65 32.5C65 56.0996 56.0996 65 32.5 65C8.90037 65 0 56.0996 0 32.5Z"
        fill="white"
      />
      <path
        d="M40.6154 23H25.3846C23.5153 23 22 24.4924 22 26.3333V39.6667C22 41.5076 23.5153 43 25.3846 43H40.6154C42.4847 43 44 41.5076 44 39.6667V26.3333C44 24.4924 42.4847 23 40.6154 23Z"
        fill="#FFC9C9"
      />
      <path
        d="M25.3846 23H40.6154C42.4854 23 44 24.4917 44 26.3333V27.1667H22V26.3333C22 24.4917 23.5146 23 25.3846 23Z"
        fill="#EB3F3F"
      />
      <path
        d="M35.8086 32.2168L38.2709 34.6418L35.8086 37.0668"
        stroke="#EB3F3F"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.1908 37.0746L27.7285 34.6496L30.1908 32.2246"
        stroke="#EB3F3F"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Building: () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 32.5C0 8.90037 8.90037 0 32.5 0C56.0996 0 65 8.90037 65 32.5C65 56.0996 56.0996 65 32.5 65C8.90037 65 0 56.0996 0 32.5Z"
        fill="white"
      />
      <path
        d="M35.5782 42.9991H24.616C23.7247 42.9991 23 42.2658 23 41.3658V27.2165C23 26.4832 23.4915 25.8333 24.1912 25.6416L33.529 23.0584C34.562 22.7751 35.5782 23.5584 35.5782 24.6333V42.9991Z"
        fill="#8646F2"
      />
      <path
        d="M37.2598 43.0009H42.2577C42.6659 43.0009 42.9991 42.6676 42.9991 42.2593V29.6599C42.9991 29.3266 42.7742 29.0266 42.4576 28.9433L38.201 27.7683C37.7346 27.635 37.2681 27.9933 37.2681 28.4849V43.0009H37.2598Z"
        fill="#BB98F7"
      />
      <path
        d="M31.8136 29.8418H26.7656V31.5167H31.8136V29.8418Z"
        fill="white"
      />
      <path
        d="M31.8136 33.4922H26.7656V35.1671H31.8136V33.4922Z"
        fill="white"
      />
      <path d="M31.8136 37.125H26.7656V38.7999H31.8136V37.125Z" fill="white" />
    </svg>
  ),
  Chart: () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 32.5C0 8.90037 8.90037 0 32.5 0C56.0996 0 65 8.90037 65 32.5C65 56.0996 56.0996 65 32.5 65C8.90037 65 0 56.0996 0 32.5Z"
        fill="white"
      />
      <path
        d="M41.946 24.5059L34.9425 30.8407L30.123 26.4438L22.5 33.5496V40.9263C22.5 42.0724 23.445 42.9997 24.6 42.9997H41.4C42.555 42.9997 43.5 42.062 43.5 40.9263V24.5059H41.946Z"
        fill="#FFC9C9"
      />
      <path
        d="M41.757 23.2672L34.9425 29.4353L30.837 25.6845C30.4275 25.3094 29.808 25.3198 29.409 25.6845L22.5 32.1235V34.9783L30.1335 27.8621L34.2285 31.6025C34.6275 31.9672 35.247 31.9672 35.646 31.6025L43.4895 24.5071V24.0278C43.4895 23.1318 42.4185 22.6734 41.7465 23.2672H41.757Z"
        fill="#EB3F3F"
      />
    </svg>
  ),
  Idea: () => (
    <svg
      width="65"
      height="65"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 32.5C0 8.90037 8.90037 0 32.5 0C56.0996 0 65 8.90037 65 32.5C65 56.0996 56.0996 65 32.5 65C8.90037 65 0 56.0996 0 32.5Z"
        fill="white"
      />
      <path
        d="M41.4869 30.5803C41.4869 25.8437 37.6845 22 32.9935 22C28.3025 22 24.5 25.8437 24.5 30.5803C24.5 32.5216 25.1468 34.3075 26.2248 35.744H26.2183L28.6553 39.1606H37.3447L39.7817 35.7505H39.7752C40.8532 34.3075 41.5 32.5216 41.5 30.5868L41.4869 30.5803Z"
        fill="#8646F2"
      />
      <path
        d="M37.3379 39.1543H28.6484V41.9109C28.6484 43.0627 29.5762 44.0009 30.713 44.0009H35.2668C36.4102 44.0009 37.3314 43.0691 37.3314 41.9109V39.1543H37.3379Z"
        fill="#BB98F7"
      />
      <path
        d="M36.6722 29.3449C36.6003 29.1896 36.437 29.099 36.2802 29.099H34.1307V26.6336C34.1307 26.4395 34.0065 26.2842 33.8236 26.213C33.6472 26.1612 33.4447 26.213 33.3205 26.3553L29.3743 31.3379C29.2698 31.4802 29.2502 31.6549 29.3221 31.7973C29.3939 31.9397 29.5573 32.0432 29.7141 32.0432H31.8505V34.5215C31.8505 34.7156 31.9746 34.8709 32.1576 34.9421C32.2098 34.9421 32.249 34.9615 32.3013 34.9615C32.445 34.9615 32.5692 34.9098 32.6606 34.7868L36.6264 29.8043C36.731 29.6619 36.7506 29.4872 36.6787 29.3449H36.6722Z"
        fill="white"
      />
    </svg>
  ),
};

const TABLET_GRAPHICS: GRAPHICS = {
  AI: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 10.9543 10.9543 0 40 0C69.0457 0 80 10.9543 80 40C80 69.0457 69.0457 80 40 80C10.9543 80 0 69.0457 0 40Z"
        fill="white"
      />
      <path
        d="M42.4126 29.275C42.4126 28.014 41.3326 27 39.9993 27C38.6659 27 37.5859 28.014 37.5859 29.275C37.5859 30.315 38.3459 31.16 39.3593 31.433V33.409H40.6259V31.433C41.6393 31.16 42.3993 30.328 42.3993 29.275H42.4126Z"
        fill="#BB98F7"
      />
      <path
        d="M39.6533 32.6934C32.5067 32.8754 27 38.7904 27 45.5374C27 47.3054 28.52 48.7354 30.3867 48.7354H49C51.2 48.7354 53 47.0454 53 44.9654C53 38.0884 46.9867 32.5244 39.6533 32.7064V32.6934ZM36.32 42.7944C35.5333 42.7944 34.88 42.1834 34.88 41.4424C34.88 40.7014 35.52 40.0904 36.32 40.0904C37.12 40.0904 37.76 40.7014 37.76 41.4424C37.76 42.1834 37.12 42.7944 36.32 42.7944ZM43.68 42.7944C42.8933 42.7944 42.24 42.1834 42.24 41.4424C42.24 40.7014 42.88 40.0904 43.68 40.0904C44.48 40.0904 45.12 40.7014 45.12 41.4424C45.12 42.1834 44.48 42.7944 43.68 42.7944Z"
        fill="#8646F2"
      />
      <rect
        x="29.332"
        y="50.4004"
        width="21.3333"
        height="2.6"
        rx="1.3"
        fill="#BB98F7"
      />
    </svg>
  ),
  Developer: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 10.9543 10.9543 0 40 0C69.0457 0 80 10.9543 80 40C80 69.0457 69.0457 80 40 80C10.9543 80 0 69.0457 0 40Z"
        fill="white"
      />
      <path
        d="M49 28H31C28.7909 28 27 29.7909 27 32V48C27 50.2091 28.7909 52 31 52H49C51.2091 52 53 50.2091 53 48V32C53 29.7909 51.2091 28 49 28Z"
        fill="#FFC9C9"
      />
      <path
        d="M31 28H49C51.21 28 53 29.79 53 32V33H27V32C27 29.79 28.79 28 31 28Z"
        fill="#EB3F3F"
      />
      <path
        d="M43.3203 39.0605L46.2303 41.9705L43.3203 44.8805"
        stroke="#EB3F3F"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.6795 44.8903L33.7695 41.9803L36.6795 39.0703"
        stroke="#EB3F3F"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Building: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 10.9543 10.9543 0 40 0C69.0457 0 80 10.9543 80 40C80 69.0457 69.0457 80 40 80C10.9543 80 0 69.0457 0 40Z"
        fill="white"
      />
      <path
        d="M43.1 52.0001H29.94C28.87 52.0001 28 51.1201 28 50.0401V33.0601C28 32.1801 28.59 31.4001 29.43 31.1701L40.64 28.0701C41.88 27.7301 43.1 28.6701 43.1 29.9601V52.0001Z"
        fill="#8646F2"
      />
      <path
        d="M45.1211 51.9993H51.1211C51.6111 51.9993 52.0111 51.5993 52.0111 51.1093V35.9892C52.0111 35.5892 51.7411 35.2292 51.3611 35.1292L46.2511 33.7192C45.6911 33.5592 45.1311 33.9892 45.1311 34.5792V51.9993H45.1211Z"
        fill="#BB98F7"
      />
      <path
        d="M38.5795 36.2109H32.5195V38.2209H38.5795V36.2109Z"
        fill="white"
      />
      <path
        d="M38.5795 40.5898H32.5195V42.5998H38.5795V40.5898Z"
        fill="white"
      />
      <path
        d="M38.5795 44.9492H32.5195V46.9592H38.5795V44.9492Z"
        fill="white"
      />
    </svg>
  ),
  Chart: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 10.9543 10.9543 0 40 0C69.0457 0 80 10.9543 80 40C80 69.0457 69.0457 80 40 80C10.9543 80 0 69.0457 0 40Z"
        fill="white"
      />
      <path
        d="M51.15 29.8086L42.8125 37.41L37.075 32.134L28 40.6606V49.5123C28 50.8875 29.125 52.0002 30.5 52.0002H50.5C51.875 52.0002 53 50.875 53 49.5123V29.8086H51.15Z"
        fill="#FFC9C9"
      />
      <path
        d="M50.925 28.3207L42.8125 35.7221L37.925 31.2212C37.4375 30.7711 36.7 30.7836 36.225 31.2212L28 38.9477V42.3733L37.0875 33.8342L41.9625 38.3225C42.4375 38.7601 43.175 38.7601 43.65 38.3225L52.9875 29.8085V29.2333C52.9875 28.1581 51.7125 27.608 50.9125 28.3207H50.925Z"
        fill="#EB3F3F"
      />
    </svg>
  ),
  Idea: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 40C0 10.9543 10.9543 0 40 0C69.0457 0 80 10.9543 80 40C80 69.0457 69.0457 80 40 80C10.9543 80 0 69.0457 0 40Z"
        fill="white"
      />
      <path
        d="M50.761 36.92C50.761 30.8918 45.8899 26 39.8805 26C33.8711 26 29 30.8918 29 36.92C29 39.3906 29.8286 41.6635 31.2096 43.4918H31.2012L34.3231 47.84H45.4547L48.5766 43.5H48.5682C49.9492 41.6635 50.7778 39.3906 50.7778 36.9282L50.761 36.92Z"
        fill="#8646F2"
      />
      <path
        d="M45.4461 47.832H34.3145V51.3403C34.3145 52.8062 35.5029 54.0003 36.9593 54.0003H42.7929C44.2576 54.0003 45.4377 52.8144 45.4377 51.3403V47.832H45.4461Z"
        fill="#BB98F7"
      />
      <path
        d="M44.5937 35.3468C44.5016 35.1491 44.2923 35.0338 44.0915 35.0338H41.3379V31.8962C41.3379 31.6491 41.1788 31.4515 40.9445 31.3609C40.7185 31.295 40.4591 31.3609 40.3 31.5421L35.2448 37.8833C35.1109 38.0644 35.0858 38.2868 35.1778 38.468C35.2699 38.6491 35.4791 38.7809 35.68 38.7809H38.4169V41.935C38.4169 42.1821 38.5759 42.3797 38.8102 42.4703C38.8772 42.4703 38.9274 42.495 38.9944 42.495C39.1785 42.495 39.3375 42.4291 39.4547 42.2727L44.5351 35.9315C44.669 35.7503 44.6941 35.528 44.602 35.3468H44.5937Z"
        fill="white"
      />
    </svg>
  ),
};

export { MOBILE_GRAPHICS, TABLET_GRAPHICS };
